import React from "react";

import { Code, Label, Typography } from "@packages/ds";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";

import { Application, Routes, Services } from "../Steps";

import * as S from "./Step.styles";

const Step = ({ project, step, subscription }) => {
  const intl = useIntl();
  const imageTypes = subscription?.project_options?.billing?.image_types;
  const filterImageType = name => {
    const allowedImageTypes =
      imageTypes?.only || project?.subscription?.image_types?.only;
    const excludedImageTypes =
      imageTypes?.exclude || project?.subscription?.image_types?.exclude;

    if (!allowedImageTypes && !excludedImageTypes) {
      return true;
    }

    let allowed = true;
    let excluded = false;

    if (allowedImageTypes) {
      allowed = allowedImageTypes.indexOf(name) !== -1;
    }

    if (excludedImageTypes) {
      excluded = excludedImageTypes.indexOf(name) !== -1;
    }
    return allowed && !excluded;
  };

  const copyableContent = code =>
    code
      ?.join?.("\n")
      .replaceAll("<project ID>", project.id)
      .replaceAll("<project REGION>", project.region);

  return (
    <S.Wrapper>
      <S.Title tag="h2">
        {step?.title}{" "}
        {!step?.required && (
          <Typography.BodyText $color="granite">
            {intl.formatMessage({ id: "wizard.step.optional" })}
          </Typography.BodyText>
        )}
      </S.Title>

      {step?.subtitle && <S.Subtitle>{step.subtitle}</S.Subtitle>}

      {step?.bodyText && (
        <S.StyledSanitizedHTML
          allowedTags={[
            "strong",
            "b",
            "br",
            "p",
            "em",
            "i",
            "a",
            "ul",
            "ol",
            "li",
            "label",
            "code"
          ]}
          html={step?.bodyText}
        />
      )}

      {/* STEPS: SERVICES */}
      {step?.id === "services" && (
        <Services filterImageType={filterImageType} />
      )}

      {/* STEPS: APPLICATION */}
      {step?.id === "application" && (
        <Application filterImageType={filterImageType} />
      )}

      {/* STEPS: ROUTES */}
      {step?.id === "routes" && <Routes />}

      {step?.copyCode &&
        step?.copyCode.map(elt => (
          <S.CodeExample key={elt.label}>
            <Label>{elt.label}</Label>
            {elt.codeType === "noCopy" ? (
              <S.NoCopyCode>
                {elt.code?.join?.("\n").replaceAll("<project ID>", project.id)}
              </S.NoCopyCode>
            ) : (
              <Code.Block
                singleLine={false}
                isCopyable={false}
                separateCopyButton={true}
              >
                {copyableContent(elt.code)}
              </Code.Block>
            )}
          </S.CodeExample>
        ))}
    </S.Wrapper>
  );
};

Step.propTypes = {
  project: PropTypes.object.isRequired,
  step: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  subscription: PropTypes.object
};

export default Step;
